import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => {
    return {
      showInitialLoader: false,
      drawer: true,
      alertCount: 0,
      adminAlertCount: 0,
    }
  },
  actions: {
    async refreshAlertCount() {
      const storeU = useUtilisateurStore()
      if (!storeU.estChargé()) return
      try {
        let nbAlertes = 0

        const results1 = await apiProphet.get('api/utilisateur/alertes/nombre')
        nbAlertes += results1.data as number

        if (storeU.siteSélectionné.id) {
          const siteCS = storeU.siteSélectionné.lettresDappel
          const results = await apiProphet.get(`sites/${siteCS}/alertes/nombre`)
          nbAlertes += results.data as number
        }

        this.alertCount = nbAlertes
      }
      catch {
        // keep last known count
      }
    },
  },
})
